import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import Button from 'modules/_shared/components/Buttons';

import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';

const SendCommunicationModalFooter: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useSendCommunicationModal();

  const isSendDisabled =
    !data.subject || !data.body || data.recipientsCount === 0;

  return (
    <Modal.Footer className="d-flex justify-content-end">
      <Button
        onClick={actions.handleSendCommunication}
        disabled={isSendDisabled}
        icon="ni ni-send"
        text={t('Send')}
        lgSize
      />
    </Modal.Footer>
  );
};

export default SendCommunicationModalFooter;
